"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathWithArgs = void 0;
var getPathWithArgs = function (path, args) {
    var finalPath = path;
    if (args.length > 0) {
        var finalOptions = args.flatMap(function (option) {
            if (Array.isArray(option)) {
                return option;
            }
            else if (typeof option === 'object') {
                return Object.entries(option).map(function (_a) {
                    var key = _a[0], value = _a[1];
                    return "".concat(key, "-").concat(value);
                });
            }
            else {
                return [option];
            }
        });
        finalPath = __spreadArray([finalPath], finalOptions, true).join(' ');
    }
    return finalPath;
};
exports.getPathWithArgs = getPathWithArgs;
